import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrLink from 'client/components/SrLink/SrLink';

const SrRenterApplicationStatusLinkButton = ({
  color,
  disabled,
  to,
  target,
  children,
  className,
}) => (
  <SrLink
    to={to}
    target={target}
    className={classnames('SrRenterApplicationStatusLinkButton', className, { disabled: disabled })}
    style={{ backgroundColor: color }}
  >
    {children}
  </SrLink>
);

SrRenterApplicationStatusLinkButton.propTypes = {
  color: PropTypes.string,
  disabled: PropTypes.bool,
  to: PropTypes.string.isRequired,
  target: PropTypes.string,
  children: PropTypes.node.isRequired,
};

SrRenterApplicationStatusLinkButton.displayName = 'SrRenterApplicationStatusLinkButton';

export default SrRenterApplicationStatusLinkButton;
